import Footer from 'components/Landing/footer';
import Header from 'components/Landing/header';

import Instructions from './index';

const LandingInstructionsPage = () => {
  return (
    <div className="min-h-screen bg-white">
      <Header />
      <main>
        <Instructions showPageHeader />
      </main>
      <Footer />
    </div>
  );
};

export default LandingInstructionsPage;
